<template>
    <div class="g-bd">
        <div class="g-hd">
            <div class="ttBox">
                <img class="back" v-show="isback" src="../assets/jxwx/return.png" alt="" @click="backward()">
                <span class="tt">{{data.departmentName}}</span>
                <span class="directorName">{{data.directorName | nameP}}</span>
            </div>
        </div>
        <div class="tabBox">
            <van-tabs class="tabWrap">
                <van-tab title="绩效">
                    <ul class="hdList">
                        <li>
                            <div class="lf">
                                <div class="tt">本月绩效累计(元)</div>
                                <div class="num">{{data.monthMoney | moneyP}}</div>
                            </div>
                            <div class="rg">
                                <div class="tt">昨日绩效(元)</div>
                                <div class="num mark">{{data.todayMoney | moneyP}}</div>
                            </div>
                        </li>
                    </ul>
                    <section class="f-bcf f-mgb">
                        <van-tabs v-model="tabName" @click="handleClick">
                            <van-tab v-for="item in tabList" :key="item.id" :title=item.tt :name=item.tt></van-tab>
                        </van-tabs>
                        <div class="chartBox">

                            <ve-line :extend="chartExtend" :data="chartData" height="220px"></ve-line>
                        </div>
                        <ul class="timeList">
                            <li v-for="(item,index) in timeList" :key="item.id" :class="{active:timeActive == index}" @click="timeChoose(index)">{{item.time}}</li>
                        </ul>
                    </section>

                    <div class="u-card detailsBox">
                        <div @click="toRecordDetail()">
                            <img src="../assets/jxwx/icon_01.png" alt="">
                            <div>绩效记录</div>
                        </div>
                        <div @click="toDirectorDetail()">
                            <img src="../assets/jxwx/icon_02.png" alt="">
                            <div>主任绩效</div>
                        </div>
                    </div>
                    <div class="u-card cardBox" v-for="item in data.groupDetail" :key="item.id" @click="toTeamLeader(item)">
                        <div class="hd">
                            <img class="icon" src="../assets/jxwx/icon_03.png" alt="">
                            <div class="tt">
                                <span>{{item.group_name}}</span>
                                <span>{{item.groupleader_name | nameP}}</span>
                            </div>
                            <img class="arr" src="../assets/jxwx/arr_05.png" alt="">
                        </div>
                        <div class="bd">
                            <div class="lf">
                                <div class="tt">本月绩效累计(元)</div>
                                <div class="num">{{item.monthtotal | moneyP}}</div>
                            </div>
                            <div class="rg">
                                <div class="tt">昨日绩效(元)</div>
                                <div class="num">{{item.daytotal | moneyP}}</div>
                            </div>
                        </div>
                    </div>
                </van-tab>
                <van-tab title="医保">
                    <van-tabs>
                        <van-tab title="门诊">
                            <div class="u-card cardBox2">
                                <div class="bd">
                                    <div class="m-hos" v-if="data2.townouthosquota == 0">
                                        <header class="f-df">
                                            <img src="../assets/jxwx/report/point.png" alt=""> 科室城镇医保
                                        </header>
                                        <div class="progress">
                                            <div class="progress_bar" :class="{'progress_bar2':data2.townouthosprop <= 80,'progress_bar3':data2.townouthosprop >= 100}" :style="{width: data2.townouthosprop + '%'}">
                                            </div>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">当前医保均次占比</span>
                                            <span class="mark nm">--</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">医保均次额度</span>
                                            <span class="nm">--</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">当前医保均次</span>
                                            <span class="nm">{{data2.townouthosavg | moneyP}}</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">医保均次剩余</span>
                                            <span class="mark nm">--</span>
                                        </div>
                                    </div>
                                    <div class="m-hos" v-else>
                                        <header class="f-df">
                                            <img src="../assets/jxwx/report/point.png" alt=""> 科室城镇医保
                                        </header>
                                        <div class="progress">
                                            <div class="progress_bar" :class="{'progress_bar2':data2.townouthosprop <= 80,'progress_bar3':data2.townouthosprop >= 100}" :style="{width: data2.townouthosprop + '%'}">
                                            </div>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">当前医保均次占比</span>
                                            <span class="mark nm">{{data2.townouthosprop}}%</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">医保均次额度</span>
                                            <span class="nm">{{data2.townouthosquota | moneyP}}</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">当前医保均次</span>
                                            <span class="nm">{{data2.townouthosavg | moneyP}}</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">医保均次剩余</span>
                                            <span class="mark nm">{{data2.townouthossurplus | moneyP}}</span>
                                        </div>
                                    </div>
                                    <div class="m-hos" v-if="data2.resouthosquota == 0">
                                        <header class="f-df">
                                            <img src="../assets/jxwx/report/point.png" alt=""> 科室居民医保
                                        </header>
                                        <div class="progress">
                                            <div class="progress_bar" :class="{'progress_bar2':data2.resouthosprop <= 80,'progress_bar3':data2.resouthosprop >= 100}" :style="{width: data2.resouthosprop + '%'}">
                                            </div>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">当前医保均次占比</span>
                                            <span class="mark nm">--</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">医保均次额度</span>
                                            <span class="nm">--</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">当前医保均次</span>
                                            <span class="nm">{{data2.resouthosavg | moneyP}}</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">医保均次剩余</span>
                                            <span class="mark nm">--</span>
                                        </div>
                                    </div>
                                    <div class="m-hos" v-else>
                                        <header class="f-df">
                                            <img src="../assets/jxwx/report/point.png" alt=""> 科室居民医保
                                        </header>
                                        <div class="progress">
                                            <div class="progress_bar" :class="{'progress_bar2':data2.resouthosprop <= 80,'progress_bar3':data2.resouthosprop >= 100}" :style="{width: data2.resouthosprop + '%'}">
                                            </div>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">当前医保均次占比</span>
                                            <span class="mark nm">{{data2.resouthosprop}}%</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">医保均次额度</span>
                                            <span class="nm">{{data2.resouthosquota | moneyP}}</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">当前医保均次</span>
                                            <span class="nm">{{data2.resouthosavg | moneyP}}</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">医保均次剩余</span>
                                            <span class="mark nm">{{data2.resouthossurplus | moneyP}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="f-bc">
                                <div class="u-card cardBox" v-for="item in data2.medicalEntity" :key="item.id" @click="toGroupDetails(item)">
                                    <div class="hd">
                                        <img class="icon" src="../assets/jxwx/report/icon_04.png" alt="">
                                        <div class="tt">
                                            <span>{{item.clinicmergedesc}}</span>
                                            <!-- <span>{{item.groupleader_name | nameP}}</span> -->
                                        </div>
                                        <img class="arr" src="../assets/jxwx/arr_05.png" alt="">
                                    </div>
                                    <div class="bd">
                                        <div class="lf">
                                            <div class="tt">当前城镇医保均次</div>
                                            <div class="num">{{item.townouthosavg | moneyP}}</div>
                                        </div>
                                        <div class="rg">
                                            <div class="tt">当前居民医保均次</div>
                                            <div class="num">{{item.resouthosavg | moneyP}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </van-tab>
                        <van-tab title="住院">
                            <div class="u-card cardBox2">
                                <div class="bd">
                                    <div class="m-hos" v-if="data2.towninhosquota == 0">
                                        <header class="f-df">
                                            <img src="../assets/jxwx/report/point.png" alt=""> 科室城镇医保
                                        </header>
                                        <div class="progress">
                                            <div class="progress_bar" :class="{'progress_bar2':data2.towninhosprop <= 80,'progress_bar3':data2.towninhosprop >= 100}" :style="{width: data2.towninhosprop + '%'}">
                                            </div>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">当前医保均次占比</span>
                                            <span class="mark nm">--</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">医保均次额度</span>
                                            <span class="nm">--</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">当前医保均次</span>
                                            <span class="nm">{{data2.towninhosavg | moneyP}}</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">医保均次剩余</span>
                                            <span class="mark nm">--</span>
                                        </div>
                                    </div>
                                    <div class="m-hos" v-else>
                                        <header class="f-df">
                                            <img src="../assets/jxwx/report/point.png" alt=""> 科室城镇医保
                                        </header>
                                        <div class="progress">
                                            <div class="progress_bar" :class="{'progress_bar2':data2.towninhosprop <= 80,'progress_bar3':data2.towninhosprop >= 100}" :style="{width: data2.towninhosprop + '%'}">
                                            </div>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">当前医保均次占比</span>
                                            <span class="mark nm">{{data2.towninhosprop}}%</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">医保均次额度</span>
                                            <span class="nm">{{data2.towninhosquota | moneyP}}</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">当前医保均次</span>
                                            <span class="nm">{{data2.towninhosavg | moneyP}}</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">医保均次剩余</span>
                                            <span class="mark nm">{{data2.towninhossurplus | moneyP}}</span>
                                        </div>
                                    </div>
                                    <div class="m-hos" v-if="data2.resinhosquota == 0">
                                        <header class="f-df">
                                            <img src="../assets/jxwx/report/point.png" alt=""> 科室居民医保
                                        </header>
                                        <div class="progress">
                                            <div class="progress_bar" :class="{'progress_bar2':data2.resinhosprop <= 80,'progress_bar3':data2.resinhosprop >= 100}" :style="{width: data2.resinhosprop + '%'}">
                                            </div>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">当前医保均次占比</span>
                                            <span class="mark nm">--</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">医保均次额度</span>
                                            <span class="nm">--</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">当前医保均次</span>
                                            <span class="nm">{{data2.resinhosavg | moneyP}}</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">医保均次剩余</span>
                                            <span class="mark nm">--</span>
                                        </div>
                                    </div>
                                    <div class="m-hos" v-else>
                                        <header class="f-df">
                                            <img src="../assets/jxwx/report/point.png" alt=""> 科室居民医保
                                        </header>
                                        <div class="progress">
                                            <div class="progress_bar" :class="{'progress_bar2':data2.resinhosprop <= 80,'progress_bar3':data2.resinhosprop >= 100}" :style="{width: data2.resinhosprop + '%'}">
                                            </div>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">当前医保均次占比</span>
                                            <span class="mark nm">{{data2.resinhosprop}}%</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">医保均次额度</span>
                                            <span class="nm">{{data2.resinhosquota | moneyP}}</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">当前医保均次</span>
                                            <span class="nm">{{data2.resinhosavg | moneyP}}</span>
                                        </div>
                                        <div class="entry">
                                            <span class="ctt">医保均次剩余</span>
                                            <span class="mark nm">{{data2.resinhossurplus | moneyP}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="f-bc">
                                <div class="u-card cardBox" v-for="item in data2.medicalEntity" :key="item.id" @click="toGroupDetails(item)">
                                    <div class="hd">
                                        <img class="icon" src="../assets/jxwx/report/icon_04.png" alt="">
                                        <div class="tt">
                                            <span>{{item.clinicmergedesc}}</span>
                                            <!-- <span>{{item.groupleader_name | nameP}}</span> -->
                                        </div>
                                        <img class="arr" src="../assets/jxwx/arr_05.png" alt="">
                                    </div>
                                    <div class="bd">
                                        <div class="lf">
                                            <div class="tt">当前城镇医保均次</div>
                                            <div class="num">{{item.towninhosavg | moneyP}}</div>
                                        </div>
                                        <div class="rg">
                                            <div class="tt">当前居民医保均次</div>
                                            <div class="num">{{item.resinhosavg | moneyP}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </van-tab>
                    </van-tabs>
                </van-tab>
            </van-tabs>
        </div>

    </div>
</template>

<script>
import api from "@/axios/api";
import { mapGetters, mapActions } from "vuex";
export default {
    computed: {
        ...mapGetters(["token"])
    },
    watch: {
        token: {
            immediate: true,
            handler: function(val) {
                if (val) {
                    this.getResultBydept(this.departmentId, this.directorId, this.today);
                    this.getDailyCountData(this.today,this.departmentId);
                }
            }
        }
    },
    data() {
        return {
            data: {},
            data2: {},
            arr: [],
            isItem: false,
            tabName: "全部",
            timeActive: 0,
            chartExtend: {
                grid: {
                    x: 20,
                    y: 40,
                    x2: 30,
                    y2: 5
                },
                series: {
                    symbol: "none"
                },
                xAxis: {
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#dedede"
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#a6a6a6",
                            fontSize: 13
                        }
                    }
                },
                yAxis: {
                    axisTick: {
                        //y轴刻度线
                        show: false
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#a6a6a6",
                            fontSize: 13
                        }
                    },
                    splitLine: {
                        //网格线
                    }
                }
            },
            chartData: {
                columns: [],
                rows: []
            },
            tabList: [
                {
                    tt: "全部"
                },
                {
                    tt: "诊查费"
                },
                {
                    tt: "收住院"
                },
                {
                    tt: "检查开单"
                },
                {
                    tt: "手术费"
                },
                {
                    tt: "检查相关"
                },
                {
                    tt: "单项统计"
                }
            ],
            timeList: [
                {
                    time: "近1月"
                },
                // {
                //     time: "近3月"
                // },
                {
                    time: "近6月"
                },
                {
                    time: "近1年"
                }
            ],
            classData: [],
            monthdayList: [],
            sixMonthList: [],
            yearList: [],
            departmentId: this.$route.query.departmentId,
            directorId: this.$route.query.directorId,
            today: this.$route.query.today,
            isback: this.$route.query.isback
        };
    },
    filters: {
        nameP: function(value) {
            if (value) {
                return value.split("(")[0];
            }
        }
    },
    mounted() {
        //  this.getResultBydept(this.departmentId, this.directorId, this.today);
        //  this.getDailyCountData(this.today,this.departmentId);
    },
    methods: {
        // isShowItem() {
        //     this.isItem = !this.isItem;
        // },
        getDailyCountData(time,id) {
            let params = {
                date: time,
                depId:id,
                deptMentId:""
            };
            api.getDailyCountData(params).then(res => {
                 this.data2 = res[0];
            });
        },
        toGroupDetails(item){
            this.$router.replace({
                path: "/jxwx/groupDetails",
                query: {
                    data:item,
                    time:this.today
                }
            });
        },
        backward() {
            this.$router.backward();
            // alert(this.$route.params.isBack)
        },
        handleClick(name) {
            this.classData = [];
            this.lineData(this.tabName);
        },
        timeChoose(index, title) {
            this.timeActive = index;
            this.classData = [];
            this.lineData(this.tabName);
        },
        lineData(itemName) {
            switch (this.timeActive) {
                case 0:
                    this.monthdayList.forEach(item => {
                        this.itemChoose(itemName, item);
                    });
                    this.chartData.rows = this.classData;
                    break;
                case 1:
                    this.sixMonthList.forEach(item => {
                        this.itemChoose2(itemName, item);
                    });
                    this.chartData.rows = this.classData;
                    break;
                case 2:
                    this.yearList.forEach(item => {
                        this.itemChoose2(itemName, item);
                    });
                    this.chartData.rows = this.classData;
                    break;
            }
        },
        itemChoose(itemName, item) {
            switch (itemName) {
                case "全部":
                    var i = {
                        日期: item[0].feedate
                    };
                    item.forEach((item, index) => {
                        let key = "组" + (index + 1);
                        i[key] = item.total;
                    });
                    this.classData.push(i);
                    break;
                case "诊查费":
                    var i = {
                        日期: item[0].feedate
                    };
                    item.forEach((item, index) => {
                        let key = "组" + (index + 1);
                        i[key] = item.examinationFee;
                    });
                    this.classData.push(i);
                    break;
                case "收住院":
                    var i = {
                        日期: item[0].feedate
                    };
                    item.forEach((item, index) => {
                        let key = "组" + (index + 1);
                        i[key] = item.inpatientNumFee;
                    });
                    this.classData.push(i);
                    break;
                case "检查开单":
                    var i = {
                        日期: item[0].feedate
                    };
                    item.forEach((item, index) => {
                        let key = "组" + (index + 1);
                        i[key] = item.checkorderFee;
                    });
                    this.classData.push(i);
                    break;
                case "手术费":
                    var i = {
                        日期: item[0].feedate
                    };
                    item.forEach((item, index) => {
                        let key = "组" + (index + 1);
                        i[key] = item.operationFee;
                    });
                    this.classData.push(i);
                case "检查相关":
                    var i = {
                        日期: item[0].feedate
                    };
                    item.forEach((item, index) => {
                        let key = "组" + (index + 1);
                        i[key] = item.checkrelatedFee;
                    });
                    this.classData.push(i);
                case "单项统计":
                    var i = {
                        日期: item[0].feedate
                    };
                    item.forEach((item, index) => {
                        let key = "组" + (index + 1);
                        i[key] = item.singleFee;
                    });
                    this.classData.push(i);
            }
        },
        itemChoose2(itemName, item) {
            switch (itemName) {
                case "全部":
                    var i = {
                        日期: item[0].month
                    };
                    item.forEach((item, index) => {
                        let key = "组" + (index + 1);
                        i[key] = item.total;
                    });
                    this.classData.push(i);
                    break;
                case "诊查费":
                    var i = {
                        日期: item[0].month
                    };
                    item.forEach((item, index) => {
                        let key = "组" + (index + 1);
                        i[key] = item.examinationFee;
                    });
                    this.classData.push(i);
                    break;
                case "收住院":
                    var i = {
                        日期: item[0].month
                    };
                    item.forEach((item, index) => {
                        let key = "组" + (index + 1);
                        i[key] = item.inpatientNumFee;
                    });
                    this.classData.push(i);
                    break;
                case "检查开单":
                    var i = {
                        日期: item[0].month
                    };
                    item.forEach((item, index) => {
                        let key = "组" + (index + 1);
                        i[key] = item.checkorderFee;
                    });
                    this.classData.push(i);
                    break;
                case "手术费":
                    var i = {
                        日期: item[0].month
                    };
                    item.forEach((item, index) => {
                        let key = "组" + (index + 1);
                        i[key] = item.operationFee;
                    });
                    this.classData.push(i);
                case "检查相关":
                    var i = {
                        日期: item[0].month
                    };
                    item.forEach((item, index) => {
                        let key = "组" + (index + 1);
                        i[key] = item.checkrelatedFee;
                    });
                    this.classData.push(i);
                case "单项统计":
                    var i = {
                        日期: item[0].month
                    };
                    item.forEach((item, index) => {
                        let key = "组" + (index + 1);
                        i[key] = item.singleFee;
                    });
                    this.classData.push(i);
            }
        },
        getResultBydept(departmentId, directorId, today) {
            let params = {
                departmentId: departmentId,
                directorId: directorId,
                today: today
                // departmentId: "1",
                // directorId: "1",
                // today: "1"
            };
            api.getResultBydept(params).then(res => {
                this.data = res.result;

                let arr = res.result.directorCurve;
                let columns = ["日期"];
                for (let i = 0; i < arr.length; i++) {
                    let name = "组" + (i + 1);
                    columns.push(name);
                }
                this.chartData.columns = columns;

                let directorCurve = this.data.directorCurve;
                let monthdayList = [];
                let sixMonthList = [];
                let yearList = [];
                for (let i = 0; i < directorCurve.length; i++) {
                    monthdayList.push(directorCurve[i].monthDetail.reverse());
                    sixMonthList.push(
                        directorCurve[i].sixmonthDetail.reverse()
                    );
                    yearList.push(directorCurve[i].yearhDetail.reverse());
                }
                let len = monthdayList[0].length;
                let len2 = sixMonthList[0].length;
                let len3 = yearList[0].length;
                for (let j = 0; j < len; j++) {
                    let arr = [];
                    for (let i = 0; i < monthdayList.length; i++) {
                        arr.push(monthdayList[i][j]);
                    }
                    this.monthdayList.push(arr);
                }

                for (let j = 0; j < len2; j++) {
                    let arr = [];
                    for (let i = 0; i < sixMonthList.length; i++) {
                        arr.push(sixMonthList[i][j]);
                    }
                    this.sixMonthList.push(arr);
                }
                for (let j = 0; j < len3; j++) {
                    let arr = [];
                    for (let i = 0; i < yearList.length; i++) {
                        arr.push(yearList[i][j]);
                    }
                    this.yearList.push(arr);
                }
                this.lineData(this.tabName);
            });
        },
        toRecordDetail() {
            this.$router.replace({
                path: "/jxwx/details",
                query: {
                    name: this.data.departmentName,
                    title: "绩效记录",
                    data: this.data.recordDetail
                }
            });
        },
        toDirectorDetail() {
            this.$router.replace({
                path: "/jxwx/details",
                query: {
                    name: this.data.directorName,
                    title: "主任绩效",
                    data: this.data.directorJXRecordDetail
                }
            });
        },
        toTeamLeader(item) {
            this.$router.replace({
                path: "/jxwx/teamLeader",
                query: {
                    groupId: item.group_id,
                    date: item.feedate,
                    isback: true
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.g-bd {
    margin-bottom: 60px;
}
.g-hd {
    padding-top: 2vw;
    background: #e5323b;
    .ttBox {
        display: flex;
        align-items: center;
        margin-left: 4vw;
        padding: 2vw 0;
        .back {
            width: 2vw;
            margin-right: 2.6vw;
        }
        .tt {
            margin-right: 4vw;
            font-size: 18px;
            color: #fff;
        }
        .directorName {
            font-size: 13px;
            color: #ff9d9e;
        }
    }
}
.hdList {
    margin-bottom: 2.6vw;
    background: #e5323b;
    li {
        display: flex;
        justify-content: space-between;
        padding: 3vw 4vw 0 4vw;
        .lf {
            text-align: left;
        }
        .rg {
            text-align: right;
        }
        .tt {
            margin-bottom: 3vw;
        }
    }
    li:first-child {
        padding-bottom: 3vw;
        .tt {
            font-size: 13px;
            color: #ff9c9d;
        }
        .num {
            font-size: 30px;
            color: #fff;
        }
        .mark {
            color: #fccd33;
        }
    }
    li:nth-child(2) {
        padding: 0;
    }
    li:nth-child(3) {
        justify-content: center;
        align-items: center;
        height: 5.3vw;
        padding: 0;
        img {
            width: 2.5vw;
        }
        .arr2 {
            transform: rotate(180deg);
        }
    }
    .itemBox {
        display: flex;
        flex-wrap: wrap;
        padding-top: 3vw;
        .item {
            width: 50%;
            box-sizing: border-box;
            padding: 2vw 4vw;
            border-bottom: 1px solid#EF5E65;
            .tt {
                margin-bottom: 2vw;
                font-size: 13px;
                color: #fff;
            }
            .lf {
                font-size: 13px;
                color: #ff9c9d;
            }
            .rg {
                font-size: 13px;
                color: #fccd33;
            }
        }
        .item:nth-child(1) {
            border-top: 1px solid#EF5E65;
        }
        .item:nth-child(2) {
            border-top: 1px solid#EF5E65;
        }
        .item:nth-child(odd) {
            border-right: 1px solid#EF5E65;
        }
    }
}


.van-tabs {
    /deep/.van-tabs__wrap {
        border-bottom: 1px solid #dedede;
    }
    /deep/.van-tab--active {
        color: #e5323b;
    }
    /deep/.van-tabs__line {
        width: 10.4vw !important;
    }
    .rankBox {
        // height: 32.6vw;
        background-color: #fff;
        .rangeList {
            li {
                display: flex;
                align-items: center;
                height: 10.6vw;
                div {
                    flex: 1;
                    text-align: center;
                    font-size: 14px;
                }
                .date {
                    color: #a6a6a6;
                }
            }
            li:first-child {
                font-size: 13px;
                color: #a6a6a6;
                background-color: #fafcff;
                border-bottom: 1px solid #dedede;
            }
        }
    }
}
.tabBox {
    /deep/.tabWrap {
        & > .van-tabs__wrap {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            border-top: 1px solid #dedede;
            border-bottom: none;
            z-index: 999;
            .van-tab--active {
                background: #e5323b;
                color: #fff;
            }
            .van-tabs__line {
                height: 0;
            }
        }
    }
}
.timeList {
    display: flex;
    background-color: #fafcff;
    height: 9.2vw;
    font-size: 13px;
    color: #a6a6a6;
    li {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        border-top: 1px solid #dedede;
    }
    li.active {
        color: #2c2c2c;
        background-color: #fff;
        border-top: 1px solid #fff;
        border-right: 1px solid #dedede;
        border-left: 1px solid #dedede;
    }
    li:first-child.active {
        border-left: none;
    }
    .customizeBtn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 14.6vw;
        height: 6.4vw;
        line-height: 1;
        border: 1px solid #0897ea;
        border-radius: 6px;
        color: #0897ea;
        box-sizing: border-box;
    }
}
.detailsBox {
    display: flex;
    padding: 4.6vw 0 3.2vw 0;
    div {
        flex: 1;
        text-align: center;
        font-size: 13px;
        img {
            width: 6vw;
            margin-bottom: 2vw;
        }
    }
}
.chartBox {
    padding-top: 3vw;
}
.u-card {
    margin: 2.6vw 4vw;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 4px 0px rgba(225, 225, 225, 0.42);
    border-radius: 6px;
}
.cardBox {
    .hd {
        display: flex;
        font-size: 13px;
        align-items: center;
        height: 12vw;
        padding: 0 4vw;
        border-bottom: 1px solid #dedede;
        .icon {
            width: 4vw;
        }
        .tt {
            display: flex;
            justify-content: space-between;
            width: 45vw;
            margin: 0 3.2vw 0 1.6vw;
        }
        .arr {
            width: 1.3vw;
        }
    }
    .bd {
        display: flex;
        justify-content: space-between;
        padding: 4vw;
        .tt {
            margin-bottom: 3.2vw;
            font-size: 13px;
            color: #a6a6a6;
        }
        .num {
            font-size: 18px;
        }
    }
}

.main {
    /deep/.van-tabs {
        margin-top: 2.6vw;
        background: #fff;
        .van-tabs__wrap {
            border-bottom: 1px solid#E0DFDF;
        }
        .van-tab--active {
            color: #5584ff;
        }
        .van-tabs__line {
            width: 16vw !important;
            background-color: #5584ff;
        }
    }
}

.u-card {
    margin: 2.6vw 4vw 0 4vw;
    // background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 1px 4px 0px rgba(225, 225, 225, 0.42);
    // border-radius: 6px;
}
.cardBox2 {
    .hd {
        display: flex;
        font-size: 13px;
        justify-content: space-between;
        align-items: center;
        height: 12vw;
        padding: 0 4vw;
        border-bottom: 1px solid #dedede;
        .icon {
            width: 4vw;
        }
        .tt {
            display: flex;
            align-items: center;
            img {
                margin-right: 1.6vw;
            }
        }
        .arr {
            width: 1.3vw;
        }
    }
    .bd {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 2vw 0 1.4vw 0;
        .m-hos {
            width: 50%;
            padding: 0 2vw;
            box-sizing: border-box;
            .f-df {
                display: flex;
                align-items: center;
            }
        }
        // .m-hos2 {
        //     width: 42vw;
        //     padding: 0 ;
        // }
        .m-hos header {
            margin-bottom: 3.4667vw;
            font-size: 14px;
            color: #4c4c4c;
        }
        .m-hos header img {
            width: 1.3333vw;
            margin-right: 1.3333vw;
        }
        .m-hos .progress {
            width: 100%;
            height: 2.1333vw;
            margin-bottom: 2.6667vw;
            border-radius: 1.0667vw;
            background-color: #efefef;
            overflow: hidden;
            .progress_bar {
                height: 100%;
                background-color: #fed100;
            }
            .progress_bar2 {
                height: 100%;
                background-color: #91C619;
            }
            .progress_bar3 {
                height: 100%;
                background-color: #F66969;
            }
        }

        .m-hos .entry {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 3.2vw;
            font-size: 12px;
        }
        .m-hos > .entry > .ctt {
            color: #8f8f8f;
        }
        .m-hos > .entry > .nm {
            font-size: 13px;
            color: #282828;
        }
        .m-hos > .entry > .mark {
            color: #f66969;
            background: #fff;
        }
        .m-hos > .entry > .mark2 {
            color: #91c619;
        }
    }
}
.f-bc {
    padding: 2.6vw 0;
    background: #f7f7f7;
    .u-card {
        margin: 2.6vw 4vw;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 4px 0px rgba(225, 225, 225, 0.42);
        border-radius: 6px;
    }
    .cardBox {
        .hd {
            display: flex;
            font-size: 13px;
            justify-content: start;
            align-items: center;
            height: 12vw;
            padding: 0 4vw;
            border-bottom: 1px solid #dedede;
            .icon {
                width: 4vw;
            }
            .tt {
                display: flex;
                justify-content: space-between;
                width: 45vw;
                margin: 0 3.2vw 0 1.6vw;
            }
            .arr {
                width: 1.3vw;
            }
        }
        .bd {
            display: flex;
            justify-content: space-between;
            padding: 4vw;
            .tt {
                margin-bottom: 3.2vw;
                font-size: 13px;
                color: #a6a6a6;
            }
            .num {
                font-size: 18px;
            }
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/jxwx/director.vue